module.exports = __webpack_public_path__ + "img/atari1200xl_ad_touchedup.f83d8903.jpg";